import { ProcedureUnitTypeRule } from '../../models/unit-type-rules-config';
import { ProcedureMapEnum } from '../../models/procedure-map.enum';
import { allTeeth } from '../teeth-sets';
import { UnitTypesInBridge } from '@modules/teeth-diagram/models/unit-type-in-bridge.enum';

export const rulesForBridgeFixedRestorativeGlidewellIo: ProcedureUnitTypeRule = {
	ProcedureMaps: [ProcedureMapEnum.FixedRestorativeGlidewellIo],
	TeethRules: [
		{
			Ids: allTeeth,
			UnitAndMaterialRules: {
				UnitTypeRules: [
					{
						Id: UnitTypesInBridge.Abutment
					},
					{
						Id: UnitTypesInBridge.Pontic
					},
					{
						Id: UnitTypesInBridge.Missing
					}
				]
			}
		}
	]
};
